import { useEffect, useState } from "react";
import { DeliveryMethod, PaymentMethod } from "../../stores/index.d";
import stripeImg from "../../resources/images/stripe-payment.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

interface IPaymentOptions {
  cashPaymentForCollection: boolean;
  cashPaymentForDelivery: boolean;
  deliveryMethod: DeliveryMethod;
  paymentMode: PaymentMethod;
  setPaymentMethod: (method: PaymentMethod) => void;
  setIsPaymentFormValid: (isValid: boolean) => void;
  isTableOrder: boolean;
}

const Payment = ({
  deliveryMethod,
  paymentMode,
  setPaymentMethod,
  setIsPaymentFormValid,
  cashPaymentForCollection,
  cashPaymentForDelivery,
  isTableOrder,
}: IPaymentOptions) => {
  const [cashConfirmationChecked, setCashConfirmationChecked] = useState(false);

  useEffect(() => {
    if (paymentMode === PaymentMethod.Cash) {
      setIsPaymentFormValid(cashConfirmationChecked);
    } else {
      setIsPaymentFormValid(true);
    }
  }, [cashConfirmationChecked, paymentMode]);

  return (
    <>
      <h6>Payment Method</h6>
      <div className="btn-group d-flex" data-toggle="buttons">
        {isTableOrder && (
          <label
            className={`btn btn-outline-secondary rounded-0 flex-fill ${
              paymentMode === PaymentMethod.Direct ? " active" : ""
            }`}
          >
            <input
              type="radio"
              name="options"
              id="option3"
              autoComplete="off"
              className="btn-check text-center"
              checked={paymentMode === PaymentMethod.Direct}
              onChange={() => setPaymentMethod(PaymentMethod.Direct)}
            />
            Pay Later
          </label>
        )}

        {((deliveryMethod == DeliveryMethod.Collection &&
          cashPaymentForCollection) ||
          (deliveryMethod == DeliveryMethod.Delivery &&
            cashPaymentForDelivery) ||
          deliveryMethod == DeliveryMethod.DineIn) && (
          <label
            className={`btn btn-outline-secondary rounded-0 flex-fill ${
              paymentMode === PaymentMethod.Cash ? " active" : ""
            }`}
          >
            <input
              type="radio"
              name="options"
              id="option1"
              autoComplete="off"
              className="btn-check text-center"
              checked={paymentMode === PaymentMethod.Cash}
              onChange={() => setPaymentMethod(PaymentMethod.Cash)}
            />
            Cash
          </label>
        )}

        <label
          className={`btn btn-outline-secondary rounded-0 flex-fill ${
            paymentMode === PaymentMethod.Card ? " active" : ""
          }`}
        >
          <input
            type="radio"
            name="options"
            id="option2"
            autoComplete="off"
            className="btn-check text-center"
            checked={paymentMode === PaymentMethod.Card}
            onChange={() => setPaymentMethod(PaymentMethod.Card)}
          />
          Card / Contactless
        </label>
      </div>

      {paymentMode === PaymentMethod.Direct ? (
        <div className="py-3 text-center">
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="fa-2x app-icon text-info me-1"
          />{" "}
          Order payment can be done later
        </div>
      ) : paymentMode === PaymentMethod.Cash ? (
        <div className="h6 custom-control custom-checkbox mt-2 pt-4 mb-5 text-center">
          <input
            type="checkbox"
            className="custom-control-input app-checkbox me-1"
            id="customCheck1"
            checked={cashConfirmationChecked}
            onChange={() =>
              setCashConfirmationChecked(!cashConfirmationChecked)
            }
          />
          <label className="custom-control-label ms-2" htmlFor="customCheck1">
            {deliveryMethod === DeliveryMethod.DineIn
              ? "Cash payment received"
              : deliveryMethod === DeliveryMethod.Collection
              ? "I will pay for this order at the shop counter on collection"
              : "I will pay for this order to the delivery agent on delivery"}
          </label>
        </div>
      ) : (
        <div className="text-center">
          <p className="h6 mt-3 mb-3">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className="fa-2x app-icon text-info me-1"
            />
            Order will be placed first then you will be redirected to Stripe
            payement page.
          </p>
          <div className="text-center">
            <div className="badge bg-dark rounded-0">Secure Payments</div>
            <div>
              <small className="text-secondary">Powered by</small>
            </div>

            <img src={stripeImg} height={60}></img>
          </div>
        </div>
      )}
    </>
  );
};

export default Payment;
